import styled from 'styled-components';
import { RowTable } from '../../../../func/components/Table';

const BiddingMethodInfo = ({ bidMethod }: any) => {
  const bidMethodArray = JSON.parse(bidMethod);
  const flattenedArray = bidMethodArray.flat();

  const data = [
    { key: '전자보증서 사용여부', value: flattenedArray[0] },
    {
      key: '공동입찰 가능여부',
      value: flattenedArray[2],
    },
    {
      key: '대리입찰 가능여부',
      value: flattenedArray[4],
    },
    {
      key: '차순위 매수신청 가능여부',
      value: flattenedArray[1],
    },
    { key: '2인 미만 유찰여부', value: flattenedArray[3] },
    { key: '2회 이상 입찰 가능여부', value: flattenedArray[5] },
  ];

  return (
    <Container id="입찰방법및입찰제한정보">
      <Block>
        <Title>입찰 방법 및 입찰 제한 정보</Title>
        <RowTable data={data} titleWidth={110} />
      </Block>
    </Container>
  );
};

export default BiddingMethodInfo;

const Container = styled.div`
  width: 100%;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Spoqa Han Sans Neo;
  background-color: #fff;
`;

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #222;
`;
